(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/snowy-background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/snowy-background.js');
"use strict";

const {
  useRef,
  useEffect
} = React;
const SnowyWorld = function (size, canvas) {
  canvas.style.filter = 'blur(2px)';
  this.gravity = [0, 9.807];
  this.size = size;
  this.update = () => {
    this.size = [canvas.width, canvas.height];
  };
};
const snowflakeDrawObj = world => {
  const {
    size
  } = world;
  const position = [Math.floor(Math.random() * size[0]), Math.random() * size[1]];
  const mass = [0, 0.2];
  const seed = Math.random() * (Math.PI * 2);
  const radius = Math.random() * 6 + 2;
  const realLifeScale = 0.01 * radius;
  const color = '#fff';
  return {
    seed,
    position,
    mass,
    update: (obj, world, delta) => {
      const {
        gravity,
        size
      } = world;
      const xOrigin = position[0];
      const oscillation = Math.sin(seed + delta / 1500) * 50;
      const newPos = seed + delta * gravity[0] * realLifeScale;
      const x = xOrigin + oscillation + newPos;
      const relativeX = x < 0 ? size[0] - Math.abs(x) % size[0] : x % size[0];
      const y = (position[1] + delta * gravity[1] * mass[1] * realLifeScale) % size[1];
      obj.position = [relativeX, y];
    },
    draw: (obj, ctx) => {
      const {
        position
      } = obj;
      const [x, y] = position;
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, 2 * Math.PI);
      ctx.closePath();
      ctx.fill();
    }
  };
};
setGlobal('svs.tickets.play.components.SnowyBackground', () => {
  const containerRef = useRef();
  const canvasRef = useRef();
  useEffect(() => {
    const world = new SnowyWorld([window.innerWidth, window.innerHeight], canvasRef.current);
    const {
      destroy
    } = svs.tickets.play.utils.particleRenderer({
      drawObject: snowflakeDrawObj,
      world,
      canvas: canvasRef.current,
      particlePerPixel: 0.0001
    });
    const onResize = _.debounce(() => {
      if (canvasRef.current) {
        canvasRef.current.height = window.innerHeight;
        canvasRef.current.width = window.innerWidth;
      }
    }, 500);
    addEventListener('resize', onResize);
    return () => {
      removeEventListener('resize', onResize);
      destroy();
    };
  }, []);
  return React.createElement("div", {
    className: "animated-background-container",
    ref: containerRef
  }, React.createElement("canvas", {
    height: window.innerHeight,
    ref: canvasRef,
    width: window.innerWidth
  }));
});

 })(window);